import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../config/api";

export const Projects = () => {

    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {

        axios
            .get(`${API_URL}/api/projects`)
            .then((response) => {

                setProjects(response.data);

            })
            .catch((error) => {

                console.log(error);

            })
            .finally(() => {

                setLoading(false);

            });

    }, []);

    return (
        <>
            {/* Page Header Start */}
            <div className="container-fluid page-header py-5">
                <div className="container text-center py-5">

                    <h1 className="display-2 text-white mb-4 animated slideInDown">
                        Our Projects
                    </h1>

                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb justify-content-center mb-0 animated slideInDown">

                            <li className="breadcrumb-item">
                                <a href="#">Home</a>
                            </li>

                            <li className="breadcrumb-item">
                                <a href="#">Pages</a>
                            </li>

                            <li
                                className="breadcrumb-item text-white"
                                aria-current="page"
                            >
                                Projects
                            </li>

                        </ol>
                    </nav>

                </div>
            </div>
            {/* Page Header End */}

            {/* Projects Start */}
            <div className="container py-5">

                <div className="row">

                    {loading ? (

                        <div className="col-12 text-center">

                            <h5>
                                Loading projects...
                            </h5>

                        </div>

                    ) : projects.length > 0 ? (

                        projects.map((project) => (

                            <div
                                className="col-lg-6 col-md-6 mb-4"
                                key={project.id}
                            >

                                <div className="card h-100 shadow-sm">

                                    <img
                                        src={project.featured_image}
                                        alt={project.title}
                                        className="card-img-top"
                                        style={{
                                            height: "300px",
                                            objectFit: "cover"
                                        }}
                                    />

                                    <div className="card-body">

                                        <h4 className="card-title">
                                            {project.title}
                                        </h4>

                                        <Link
                                            to={`/projects/${project.slug}`}
                                            className="btn btn-primary"
                                        >
                                            Read More
                                        </Link>

                                    </div>

                                </div>

                            </div>

                        ))

                    ) : (

                        <div className="col-12 text-center">

                            <h5>
                                No projects found.
                            </h5>

                        </div>

                    )}

                </div>

            </div>
            {/* Projects End */}
        </>
    );
};